import {useEffect, useState} from 'react';

type ResultEventDetail = {
    solved: boolean;
};

type useSolvedStatusReturnType = {
    solvedStatus: Record<string, boolean>;
    levelName: string;
};

function useSolvedStatus(): useSolvedStatusReturnType {
    const [solvedStatus, setSolvedStatus] = useState<Record<string, boolean>>(
        {}
    );
    const [levelName, setLevelName] = useState<string>('');

    function getLevelName(): string {
        const levelFromUrl = new URLSearchParams(window.location.search)
            .get('name')
            ?.toLowerCase();
        if (levelFromUrl) return levelFromUrl;

        const nextButtonText = document.getElementById(
            'app-navbar-control-next'
        )?.innerText;
        if (nextButtonText) {
            const name = nextButtonText.split(' ');
            if (name.length < 2) return '';

            return name[1].toLowerCase();
        }
        return '';
    }

    useEffect(() => {
        setLevelName(getLevelName());
    }, []);

    useEffect(() => {
        const handleResultEvent = (event: CustomEvent<ResultEventDetail>) => {
            const {solved} = event.detail;

            const solveStatusContainer = document.getElementById(
                'solve-status-container'
            );
            if (solveStatusContainer) {
                solveStatusContainer.innerHTML = solved
                    ? '<a class="btn btn-outline-success btn pe-none border-0 px-1" href="#"><i class="fa-solid fa-circle-check"></i></a>'
                    : '<a class="btn btn-outline-danger btn pe-none border-0 px-1" href="#"><i class="fa-solid fa-circle-xmark"></i></a>';
            }

            if (solved) {
                const level = getLevelName();

                setSolvedStatus(prevStatus => ({
                    ...prevStatus,
                    [level]: true,
                }));
            }
        };

        document.addEventListener(
            'goproblems_player.result',
            handleResultEvent as EventListener
        );

        return () => {
            document.removeEventListener(
                'goproblems_player.result',
                handleResultEvent as EventListener
            );
        };
    }, []);

    return {solvedStatus, levelName};
}

export default useSolvedStatus;
